import { ModuleDto } from '../../../../core/src/lib/dto/modules/module-dto';
import { ModuleType } from '../../../../core/src/lib/enum/module-type.enum';
import { IModuleModel } from '../../../../core/src/lib/interface/module/module.model';

export class ModuleMapper {
    public mapModulesFromModulesDto(modules: ModuleDto[]): IModuleModel[] {
        return modules.map(module => {
            let parsedSettings = null;
            try {
                parsedSettings = JSON.parse(module.settings as string);
            } catch {
                /* empty */
            }
            return {
                module: module.name as ModuleType,
                settings: parsedSettings,
            } as IModuleModel;
        });
    }

    public mapModulesToTypedModule<T>(moduleType: ModuleType, modules: IModuleModel[]): IModuleModel<T> {
        const match = modules.find(module => module.module === moduleType);

        return {
            module: moduleType,
            settings: match?.settings as T,
        } as IModuleModel<T>;
    }

    public mapModuleFromDto<T>(moduleType: ModuleType, modules: ModuleDto[]): IModuleModel<T> {
        const match = modules.find(module => module.name === moduleType.toString());

        return {
            module: moduleType,
            settings: match?.settings as T,
        } as IModuleModel<T>;
    }
}
